<template>
  <Layout>
    <div class="flex items-baseline">
      <h1 class="h1">Wijzig {{ contact.name }}</h1>
    </div>
    <div class="my-8 flex flex-col-reverse lg:flex-row -mx-5">
      <div class="lg:w-2/3 mx-5">
        <CompanyForm
          method="patch"
          :action="`/json/contacts/${id}`"
          :contact="contact"
          @success="success"
          @cancel="back"
        />
      </div>
      <div class="lg:w-1/3 mx-5 mb-10"></div>
    </div>
  </Layout>
</template>

<script>
import store from "@/store";
import CompanyForm from "@/components/CompanyForm";

export default {
  props: {
    id: [Number, String]
  },

  metaInfo() {
    return { title: `Wijzig ${this.contact.name}` };
  },

  components: {
    CompanyForm
  },

  computed: {
    contact() {
      return this.$store.state.contact;
    }
  },

  beforeRouteEnter(to, from, next) {
    store.dispatch("loadContact", to.params.id).then(() => next());
  },

  methods: {
    success(contact) {
      this.$store.commit("SET_CONTACT", contact);
      this.$router.push({ name: "contacts.show", params: { id: this.id } });
    },

    back() {
      this.$router.push({ name: "contacts.show", params: { id: this.id } });
    }
  }
};
</script>
